// Animated plus/minus toggle icon, drawn with two pseudo-element bars rather
// than an SVG so the two states can morph into each other (see
// assets/styles/fragments/_icons.scss).
//
// The open state is a class on the icon itself, not an ancestor selector, so it
// works regardless of where the toggle button sits relative to the icon —
// Accordion has the icon as a sibling of an overlay button.
export default function IconPlus({ open = false, className = '' }) {
  return (
    <span
      className={`iconPlus${open ? ' is-open' : ''}${
        className ? ` ${className}` : ''
      }`}
      aria-hidden="true"
    />
  );
}
